module.exports = __webpack_public_path__ + "img/ctu_banner_btn.d1faf681.png";